<script setup>
/* eslint-disable */
</script>
<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4652 13.4652C12.468 14.2252 11.2538 14.6463 10.0002 14.6668C5.91683 14.6668 3.5835 10.0002 3.5835 10.0002C4.3091 8.64793 5.31549 7.46651 6.53516 6.53516M8.77516 5.47349C9.17669 5.37951 9.58778 5.33252 10.0002 5.33349C14.0835 5.33349 16.4168 10.0002 16.4168 10.0002C16.0627 10.6626 15.6404 11.2863 15.1568 11.861M11.2368 11.2368C11.0766 11.4088 10.8834 11.5467 10.6688 11.6423C10.4541 11.738 10.2224 11.7894 9.98738 11.7935C9.75241 11.7977 9.51901 11.7545 9.3011 11.6664C9.0832 11.5784 8.88525 11.4474 8.71907 11.2812C8.5529 11.1151 8.42189 10.9171 8.33388 10.6992C8.24586 10.4813 8.20264 10.2479 8.20678 10.0129C8.21093 9.77797 8.26236 9.54624 8.35801 9.33157C8.45365 9.11691 8.59156 8.9237 8.7635 8.76349M3.5835 3.5835L16.4168 16.4168"
      stroke="currentColor"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
